import React from "react";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import DownloadIcon from "@mui/icons-material/GetApp";
import DeleteIcon from "@mui/icons-material/DeleteOutline";
import { IconButton, Stack } from "@mui/material";
import { urlCheck } from "../../utility/url-check";
import { GenerateNewDocumentUrl } from "../../utility/generate-new-document-url";
import useFieldDisabled from "../../hooks/useFieldDisabled";

const PDFsContainerComponent = (props: any) =>{
    const {file, view, files, document, deleteClick, path, folder} = props;

	const { isHoaFieldDisabled } = useFieldDisabled();

	const onClick = async () => {
		const newUrl = await GenerateNewDocumentUrl.getNewUrl(file.url, path, folder);
		if(newUrl && path && folder) {
			window.open(urlCheck(newUrl), '_blank');
		} else {
			window.open(urlCheck(file.url), '_blank');
		}
	}
	
	return (
		<>        
		{view == 'update' || view == 'add'?
			<div style={{ cursor: "pointer" }} className="ov-pdf-container" >
				<Stack direction={"row"} alignItems={"center"}>
					<PictureAsPdfIcon style={{ width: "20px", height: "20px" }} />
					<span style={{ marginLeft: "14px" }} className="text-3E3E3E-14px normal">
						{file.fileName ? file.fileName : file.name}
					</span>
				</Stack>
				<Stack direction={"row"} alignItems={"center"}>
					{ file.fileName ? <DownloadIcon style={{ width: "20px", height: "20px", color: "#3576E5" }} onClick={onClick}/>: '' }
					<IconButton disabled={isHoaFieldDisabled(document) || false}>
						<DeleteIcon onClick={() => deleteClick(document, file)} style={{ width: "20px", height: "20px", color: "#3576E5" }} />
					</IconButton>
				</Stack>
			</div>: 
			<div style={{ cursor: "pointer" }} className="ov-pdf-container" onClick={onClick}>
				<Stack direction={"row"} alignItems={"center"}>
					<PictureAsPdfIcon style={{ width: "20px", height: "20px" }} />
					<span style={{ marginLeft: "14px" }} className="text-3E3E3E-14px normal">
						{file.fileName}
					</span>
				</Stack>
				<DownloadIcon style={{ width: "20px", height: "20px", color: "#3576E5" }} />
			</div>
		}</>
	);
};
export default PDFsContainerComponent;